import MenuItem from './MenuItem'
const Menu = ({form,stats}) =>{
   const itemMenus =
      {
         "products" : 
          [
            {href:"/products",title:"Producto Activos"},
            {href:"/products/new",title:"Nuevo Producto"}
          ],
         "setting" : [
           {href:"/mi-perfil",title:"Mi perfil"},
           {href:"/mi-firma-sms",title:"Mi Firma SMS"},
           {href:"/mi-firma-email",title:"Mi Firma EMAIL"},
           {href:"/cambiar-clave",title:"Cambiar mi contraseña"}
         ],
         "web" : [
          {href:"/menu-posicion",title:"Menu Posición"},
          {href:"/landing",title:"Landing Home"},
          //{href:"/banner-lateral",title:"Tracking Web"},
          {href:"/tracker-web",title:"Tracking Web"},
          {href:"/tracker-compra",title:"Flujo de Compra"},
          {href:"/zona-location-patio",title:"Patio monigote location"},
          {href:"/calenadrio-patio",title:"Patio monigote calendario"},
          {href:"/legales",title:"Legales"},
         ]
      }

	return (
    <div className="menu-sidebar">
      <ul className="left-menu-list">
         {
          (
            form.includes("banner-lateral") ||
            form.includes("banner-web") ||
            form.includes("menu-posicion") ||
            form.includes("tracker-web") ||
            form.includes("/")
          )
            ?
           <MenuItem title="Configuración Web" ico_class="active ico-settings"
              has_submenu={true}
              list_sub_menu={itemMenus["web"]}
            />            
            :
             <MenuItem title="Configuración Web" ico_class="ico-settings"
                has_submenu={true}
                list_sub_menu={itemMenus["web"]}
              />            
          }


         {
          form.includes("team")  ?
            <MenuItem href="/team" title="Mi equipo" ico_class="active ico-team" counter={-1} />
         :
            <MenuItem href="/team" title="Mi equipo" ico_class="ico-team" counter={-1} />
          }

         {
          (
            form.includes("mi-perfil") ||
            form.includes("mi-firma-sms") ||
            form.includes("mi-firma-email") ||
            form.includes("cambiar-clave")
          )
            ?
           <MenuItem title="Configuración" ico_class="active ico-settings"
              has_submenu={true}
              list_sub_menu={itemMenus["setting"]}
            />            
            :
             <MenuItem title="Configuración" ico_class="ico-settings"
                has_submenu={true}
                list_sub_menu={itemMenus["setting"]}
              />            
          }




         <li className="active-sync" id="sync-text">
            <div className="ms-float-modal-alert">
               <i className="active-sync-bullet"></i>
               <div className="ms-body">
               </div>
            </div>
         </li>
      </ul>
    </div>
	)
}

export default Menu